import React from "react";
import { Skeleton } from "./Skeleton";

const CARD_COUNT = 4;

/**
 * Skeleton for Needs Your Attention section (list of attention cards).
 * Matches AttentionItemCard layout: left bar, title, description, action.
 */
export function AttentionSectionSkeleton() {
  return (
    <div className="flex w-full flex-col items-start gap-3">
      {Array.from({ length: CARD_COUNT }).map((_, i) => (
        <div
          key={i}
          className="flex w-full items-center justify-between rounded-lg border-l-4 border-solid border-neutral-200 bg-neutral-50 px-5 py-4"
        >
          <div className="flex items-start gap-4">
            <Skeleton className="h-2 w-2 flex-none rounded-full mt-1.5" />
            <div className="flex flex-col items-start gap-2">
              <Skeleton className="h-5 w-48" />
              <Skeleton className="h-4 w-64" />
            </div>
          </div>
          <Skeleton className="h-4 w-24" />
        </div>
      ))}
    </div>
  );
}
